<!-- Content -->
<div class="w-full">
  <div class="flex flex-column row-gap-1">
    @if (slideAuthorFacade.currentSelectedSlideKeymapColumns$ | async; as keymapColumns) {
      @for (keymapColumn of keymapColumns; track trackByKeymapColumn(i, keymapColumn); let i = $index) {
        <div
          class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 node">
          <div class="flex flex-grow-1 flex-row column-gap-1 align-items-center mb-2 p-1 pl-2 h-row border-round hover:surface-hover cursor-pointer h-3rem"
            [class.bg-white-alpha-10]="activeIndex === i"
            (click)="onMenuExpand(i)">
            <div class="flex w-2rem">
              <button medsurf-design-input-button [id]="'keymap_column_column_toggle'"
                [title]="(activeIndex !== i ? 'global.choice_toggle_open' : 'global.choice_toggle_close') | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
              [iconClass]="(activeIndex !== i ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"></button>
            </div>
            <div class="flex flex-grow-1 p-2 w-0">
              <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ 'global.column' | translate }} {{ i + 1 }}
              </span>
            </div>
            <div [hidden]="activeIndex !== i"
              class="flex flex-shrink-0 flex-row flex-nowrap column-gap-2 justify-content-end">
              <button medsurf-design-input-button [id]="'keymap_column_remove'"
                [title]="'global.column_remove' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_SMALL_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
              (click)="removeKeymapColumn(keymapColumn)"></button>
              <button medsurf-design-input-button [id]="'keymap_label_add'"
                [title]="'global.keymap_label_add' | translate"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_OUTLINED"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
              (click)="addKeymapLabel(keymapColumn)"></button>
            </div>
          </div>
          @if (slideAuthorFacade.keymapLabels$(keymapColumn.labels) | async | sortBy_shared:'asc':'order'; as keymapLabels) {
            <div
              [hidden]="activeIndex !== i"
              class="flex flex-column row-gap-2">
              <!-- Labels -->
              @for (keymapLabel of keymapLabels; track trackByKeymapLabel($index, keymapLabel)) {
                <medsurf-slide-edit-keymap-label-form
                [keymapLabel]="keymapLabel"></medsurf-slide-edit-keymap-label-form>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>